import { render, staticRenderFns } from "./activity-session-game-form.vue?vue&type=template&id=54e69bd9&"
import script from "./activity-session-game-form.vue?vue&type=script&lang=ts&"
export * from "./activity-session-game-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports